import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ActionList,
  ActionListGroup,
  ActionListItem,
  Button,
  // CompassHero,
  Content,
  ContentVariants,
  Hero,
  Label
} from "@patternfly/react-core";

import "../../home/heroes/HomeHero.css";

import { getHeroGradient } from "../../../config/hero";

const AnnouncementHero = ({
  announcement,
  gradientVariant = "blue",
  useGradient = false,
  carouselControls
}) => {
  const [imageOrientation, setImageOrientation] =useState(null);

  const heroGradient = getHeroGradient(gradientVariant);

  const {
    id,
    title = "",
    excerpt = "",
    publishedAt,
    url,
    image,
    showHeroImage = true
  } = announcement || {};


  if (!announcement) {
    return null;
  }

  const handleImageLoad = (event) => {
    const {
      naturalWidth,
      naturalHeight
    } = event.currentTarget;

    if (!naturalWidth || !naturalHeight) {
      return;
    }

    const ratio = naturalWidth / naturalHeight;

    if (ratio < 0.9) {
      setImageOrientation("portrait");
      return;
    }

    if (ratio <= 1.1) {
      setImageOrientation("square");
      return;
    }

    setImageOrientation("landscape");
  };

  const publishDate = publishedAt
    ? new Date(publishedAt).toLocaleDateString("pl-PL", {
        day: "numeric",
        month: "long",
        year: "numeric"
      })
    : "";
  
    const detailsUrl = id
      ? `/announcements/${id}`
      : url;
  return (
    // <CompassHero className="school-home-hero-wrapper">
      <Hero
        isGlass
        className="school-home-hero school-announcement-hero"
        bodyWidth="100%"
        bodyMaxWidth="100%"
        {...(
          useGradient
            ? {
                gradientLight: heroGradient.light,
                gradientDark: heroGradient.dark
              }
            : {}
        )}
      >
        <div className="school-home-hero__layout">
          <div className="school-home-hero__content">
            <div className="school-home-hero__meta">
              <Label variant="outline" color="blue">
                Ogłoszenie
              </Label>

              {publishDate && (
                <Content component={ContentVariants.small}>
                  {publishDate}
                </Content>
              )}
            </div>

            <Content
              component={ContentVariants.h1}
              className="school-home-hero__title"
            >
              {title}
            </Content>

            {excerpt && (
              <Content
                component={ContentVariants.p}
                className="school-home-hero__excerpt"
              >
                {excerpt}
              </Content>
            )}

            <div className="school-home-hero__spacer" />

            <ActionList>
              <ActionListGroup>
                {/* {url && (
                  <ActionListItem>
                    <Button
                      component="a"
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="primary"
                    >
                      Zobacz ogłoszenie
                    </Button>
                  </ActionListItem>
                )} */}
                {id && (
                  <ActionListItem>
                    <Button
                      component={Link}
                      to={detailsUrl}
                      variant="primary"
                    >
                      Zobacz ogłoszenie
                    </Button>
                  </ActionListItem>
                )}

                {/* <ActionListItem>
                  <Button
                    component="a"
                    href="/ogloszenia"
                    variant="secondary"
                  >
                    Wszystkie ogłoszenia
                  </Button>
                </ActionListItem> */}
              </ActionListGroup>
            </ActionList>
          </div>
          
          {showHeroImage && image?.src && (
            <Link
              to={detailsUrl}
              className={[
                "school-home-hero__media",
                imageOrientation
                  ? `school-home-hero__media--${imageOrientation}`
                  : "school-home-hero__media--loading"
              ].join(" ")}
              aria-label={`Przeczytaj ogłoszenie: ${title}`}
            >
              <img
                src={image.src}
                alt={image.alt || title}
                className="school-home-hero__image"
                onLoad={handleImageLoad}
              />
            </Link>
          )}

        </div>
        {carouselControls && (
          <div className="school-home-hero__footer">
            {carouselControls}
          </div>
        )}
      </Hero>
    // </CompassHero>
  );
};

export default AnnouncementHero;